// Compiler result to JSON file
import { createComponent } from 'js/declViewModelService';
import { registerDynImportEntry } from 'js/moduleLoader';
import AwParseService from 'js/awParseService';
import AwFilterService from 'js/awFilterService';
import { getField } from 'js/utils';
import { Fragment } from 'react';
let filterSer = AwFilterService.instance;

/*
render function
*/
import { searchHistoryCellRenderFunction } from 'js/searchHistoryCellService';

/*
ctx imports
*/

const ctxImportObj = {};

/*
dynamic import
 */
registerDynImportEntry('js/searchHistoryCellService', () => import('js/searchHistoryCellService'));
;

/*
view model
 */
const declViewModelJson = {
  "schemaVersion": "1.0.0",
  "actions": {
    "render": {
      "method": "searchHistoryCellRenderFunction",
      "deps": "js/searchHistoryCellService"
    }
  },
  "data": {},
  "conditions": {},
  "onEvent": [],
  "lifecycleHooks": {
    "render": "render"
  },
  "props": {
    "item": {
      "type": "viewModelObject"
    },
    "vmo": {
      "type": "viewModelObject"
    },
    "hideoverlay": {
      "type": "string"
    },
    "accsessionid": {
      "type": "string"
    }
  },
  "_viewModelId": "SearchHistoryCell",
  "_uniqueViewModelId": "SearchHistoryCell",
  "ctx": {}
};

/*
define component
*/
const Component = createComponent(declViewModelJson, searchHistoryCellRenderFunction, undefined, ctxImportObj);
export default Component;